<template>
  <div>
    <div class="head">
      <el-upload
        class="upload-demo"
        action="/v1/companyorg/uploadFile"
        :on-success="uploadSuccess"
        :show-file-list='false'>
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </div>
    <div class="bodyBox">
        <div class="imgBox">
          <img :src="imgurl" alt="">
        </div>
    </div>
  </div>
</template>

<script>
import { getOrganization, addOrganization, editOrganization } from '@/api/wholeProcess'
export default {
  name: 'organizational',
  data() {
    return {
      imgurl: '',
      imgArr: [], //后端传过来得图片数组，接受在这里用于判断length length为0就调新增接口 不为0就掉编辑接口
    }
  },
  methods: {
    uploadSuccess(file){
      // console.log(file)
      this.imgurl = file.msg
      // 新增
      if(this.imgArr.length === 0) {
        let addData = {
          fileUrl: file.msg
        }
        addOrganization(addData).then((res) => {
          this.getOrganizationImg();
        })
      }else{
        // 编辑
        let editData = {
          fileUrl: file.msg,
          id: this.imgArr[0].id
        }
        editOrganization(editData).then((res) => {
          this.$message.success('修改成功,图片过大的话可能要稍等几秒')
          this.getOrganizationImg();
        })
      }
    },
    getOrganizationImg(){
      getOrganization().then(res => {
        console.log(res);
        if(res.body.data.length === 0){
          this.imgurl = ""
        }else{
          this.imgurl = res.body.data[0].fileUrl;
        }
        this.imgArr = res.body.data
      })
    }
  },
  created() {
    this.getOrganizationImg();
  }
}
</script>

<style scoped>
  .head {
    display: flex;
    justify-content: space-between;
  }
  .bodyBox {
    width: 100%;
    height: 860px;
    margin: auto;
    background: white;
    padding: 15px;
  }
  .innerBox {
    padding-top: 20px;
    width: 100%;
    height: 830px;
    background-color: rgb(82, 86, 89);
    overflow-y: scroll;
  }
  .imgBox {
    display: flex;
  }
  .imgBox img {
    margin: auto;
    min-width: 600px;
  }
</style>
